import request from '@/common/utils/request.js'

export default {
    getArticle(params) {
        let url = 'demo';
        return request.get(url, {
            params: params
        });
    }
}